export default "__VITE_ASSET__BkK2CAcT__"